import { selectCurrentPlanByProduct } from './selectCurrentPlanByProduct'

export const selectCurrentKb = state => {
  return selectCurrentPlanByProduct(state, 'kb')
}
